// U-Guarantee-Slider
  document.addEventListener("DOMContentLoaded", function(){
    new Swiper(".guaranteeswiper", {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".guaranteeswiper .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 1 },
        769: { slidesPerView: 1 },
        1024: { slidesPerView: 4 }
      }
    });
  });
// U-Reviews
    document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.u-reviews-swiper');
    if(!el) return;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  });
// U-Announcement-Bar
    document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".announcement-swiper", {
      slidesPerView: 1,              
      centeredSlides: false,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 3,           
          centeredSlides: false,
        }
      }
    });
  });
// U-Image-SLider
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".u-image-swiper", {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".u-image-slider .swiper-button-next",
      prevEl: ".u-image-slider .swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      888: {
        slidesPerView: 4,
        spaceBetween: 10,
      },      
      1000: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  });
});


function toggleProductInCart(checkbox) {
    var productId = checkbox.value;
    console.log('Product ID:', productId);

    if (checkbox.checked) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: productId,
                quantity: 1
            },
            dataType: 'json',
            success: function(response) {
                console.log('Added to cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error adding to cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    } else {
        // Handle removing the product from the cart
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: productId,
                quantity: 0
            },
            dataType: 'json',
            success: function(response) {
                console.log('Removed from cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error removing from cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    }
}

// Reload the content of a div with a specific ID using jQuery
function reloadDivContent(divId) {
  console.log("Reloading Div.....")
  $.get(window.location.href, function(data) {
    var newContent = $(data).find('#' + divId).html();
    $('#' + divId).html(newContent);
  });
  console.log("Reloaded Div.....")
  
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelector(".product-form__add-btn")?.addEventListener("click", function () {
        setTimeout(() => {
            let shippingCheckbox = document.querySelector("#mshipping-toggle-input");
            if (shippingCheckbox && !shippingCheckbox.checked) {
                shippingCheckbox.checked = true;
                shippingCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }, 3000);
    });
});
